import React from "react";
import ScrollContainer from "react-indiana-drag-scroll";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import { useRef } from "react";

function HorizontalList({ language, content, callback, themeColor, is_scrollAble = true }) {
  const containerRef = useRef(null);

  return (
    <>
      <div className={`d-flex  align-items-center w-100`}>
        {is_scrollAble && <ArrowBackIosIcon className="pointer mx-2   " onClick={() => (containerRef.current.container.current.scrollLeft += -100)} />}
        <ScrollContainer
          vertical={false}
          ref={containerRef}
          style={{
            width: "100%",
            overflowY: "hidden",
          }}
          className={`d-flex  ${!is_scrollAble ? "justify-content-center" : ""}
            
            ${language === "arabic" ? "flex-row-reverse" : ""}
            `}
        >
          {content}
        </ScrollContainer>
        {is_scrollAble && <ArrowForwardIosIcon className="mx-2 pointer" onClick={() => (containerRef.current.container.current.scrollLeft += 100)} />}
      </div>
    </>
  );
}

export default HorizontalList;
